import React from "react";

export default function MentionsLegales() {
  return (
    <div className="container-page py-16 sm:py-24" data-testid="page-mentions">
      <p className="eyebrow mb-4">Mentions légales</p>
      <h1 className="font-heading text-3xl sm:text-4xl font-medium text-ink mb-8">
        Mentions légales
      </h1>
      <div className="prose prose-stone max-w-3xl text-ink-muted leading-relaxed space-y-4">
        <p>
          <strong>Éditeur :</strong> Association Petits Pas — École Pleine Nature, 45 route de Montégut, Lieu-dit Lambège, 09200 Moulis.
        </p>
        <p>
          <strong>Contact :</strong> contact@ecolepleinenature.org — 09 80 61 52 98
        </p>
        <p>
          <strong>Hébergement :</strong> Information disponible sur demande.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication, adaptation de tout ou
          partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
          sauf autorisation écrite préalable.
        </p>
      </div>
    </div>
  );
}
